import React from 'react'

interface FlashbarItem {
  type?: 'success' | 'error' | 'warning' | 'info'
  content: React.ReactNode
  dismissible?: boolean
  onDismiss?: () => void
  id?: string
}

interface FlashbarProps {
  items: FlashbarItem[]
}

export const Flashbar: React.FC<FlashbarProps> = ({ items }) => {
  const colors = {
    success: { bg: '#d4edda', border: '#c3e6cb', text: '#155724' },
    error: { bg: '#f8d7da', border: '#f5c6cb', text: '#721c24' },
    warning: { bg: '#fff3cd', border: '#ffeaa7', text: '#856404' },
    info: { bg: '#d1ecf1', border: '#bee5eb', text: '#0c5460' },
  }

  return (
    <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 2000, maxWidth: '400px' }}>
      {items.map((item, idx) => {
        const style = colors[item.type || 'info']
        return (
          <div
            key={item.id || idx}
            style={{
              backgroundColor: style.bg,
              border: `1px solid ${style.border}`,
              color: style.text,
              padding: '12px 16px',
              borderRadius: '4px',
              marginBottom: '8px',
              position: 'relative',
            }}
          >
            {item.dismissible && (
              <button
                onClick={item.onDismiss}
                style={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: style.text,
                }}
              >
                ×
              </button>
            )}
            {item.content}
          </div>
        )
      })}
    </div>
  )
}
